export const ADMIN_LOGIN = "admin/login";
export const ADMIN_LOGOUT = "admin/logout";
export const ADMIN_LOGIN_SUCCESS = "admin/login/success";
export const ADMIN_LOGIN_ERROR = "admin/login/error";
export const ISLoding = "isLoading";
